import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDIkIFZ0ehQHQsxk9PYXgn9ukZmev4iyjY",
  authDomain: "lea-s-library.firebaseapp.com",
  projectId: "lea-s-library",
  storageBucket: "lea-s-library.firebasestorage.app",
  messagingSenderId: "890519086054",
  appId: "1:890519086054:web:79af4d8f34227c37f46c27"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
